export default __webpack_public_path__ + "static/media/app-store-badge.0e201f47.svg";